import { Component, OnInit, ViewChild } from '@angular/core';
import { Usuario } from 'src/app/Models/usuario/usuario';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';
import { InfoComponent } from '../../objects/info/info/info.component';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { NothingComponent } from '../../objects/nothing/nothing.component';
import { Compra } from 'src/app/Models/compra/compra/compra';
import { AlertComponent } from '../../objects/alert/alert/alert.component';

@Component({
  selector: 'app-compras-informes',
  templateUrl: './compras-informes.component.html',
  styleUrls: ['./compras-informes.component.css']
})
export class ComprasInformesComponent implements OnInit {
  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(NothingComponent, null) public nothing: NothingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;
  public usuario:Usuario=new Usuario();
  public compras:Compra[] = [];
  public totalventas:number = 0;
  public totalefectivo:number = 0;
  public totaltarjetas:number = 0;
  constructor(private data: DataService, private notify: NotifyService,private auth:AuthService) { }

  ngOnInit() {
    this.usuario = this.auth.getCurrentUser();
    this.GetData();
  }



  GetData(){
    this.loading.show('cargando datos');
    this.data.GetSimple(this.data.api.compra).subscribe(r => {
      if (r.length < 1) {
          console.log(r);
          this.compras=[];
      }else{
          console.log(r);
          this.compras=r;
          console.log("Resultado");
          console.log(this.compras);
          this.loading.hide();
      }
    }, e => { console.log(e); },()=>this.GetTotalVentas());
  }

  GetTotalVentas(){
    this.totalventas = 0;
    //this.totalefectivo = 0;
    this.totaltarjetas = 0;

    this.compras.forEach(compra => {
      this.totalventas+= +compra.total
      //this.totalefectivo+= +compra.total
      this.totaltarjetas+= +compra.tarjetachq
    });

    // console.log(this.sumacantidad);
    // console.log(this.sumapreuni);
    // console.log(this.sumatotal);

  }
}
